module.exports = __webpack_public_path__ + "img/phone.e6ee3e80.png";